import { JsonObject, JsonProperty } from 'json2typescript';
import { DateConverter } from '@shared/entities/converters/date-converter';

@JsonObject('SFContact')
export class SFContact {
  @JsonProperty('id', String)
  public id?: string = undefined;

  @JsonProperty('accountId', String)
  public accountId?: string = undefined;

  @JsonProperty('lastName', String)
  public lastName?: string = undefined;

  @JsonProperty('firstName', String)
  public firstName?: string = undefined;

  @JsonProperty('phone', String)
  public phone?: string = undefined;

  @JsonProperty('mobilePhone', String)
  public mobilePhone?: string = undefined;

  @JsonProperty('email', String)
  public email?: string = undefined;

  @JsonProperty('createdDate', DateConverter)
  public createdDate?: Date = undefined;

  @JsonProperty('myICAM__c', Boolean)
  public myICAM?: boolean = false;

  @JsonProperty('roleMyICAM__c', String)
  public roleMyICAM?: string = undefined;

  @JsonProperty('profileMyICAM__c', String)
  public profileMyICAM?: string = undefined;
}
